import { styled } from '@mui/material/styles';
import { Box, Button, TextField, Typography } from '@mui/material';

export const GameEditorContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    padding: theme.spacing(2),
    width: '50%',
    marginRight: '10%',
    height: '100%',
}));

export const GameEditorRightAllignetContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'right',
    padding: theme.spacing(2),
    width: '100%',
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
    fontSize: '1.125rem',
    fontWeight: 600,
    color: theme.palette.text.secondary,
}));

export const StyledTextField = styled(TextField)({
    '& fieldset': {
        borderRadius: '19px',
    },
    '& .MuiOutlinedInput-root': {
        height: 38,
    },
});

export const PointsTextField = styled(TextField)({
    width: 80,
    '& fieldset': {
        borderRadius: '19px',
    },
    '& .MuiOutlinedInput-root': {
        height: 38,
    },
});

export const StyledAddEventButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(1),
}));

export const EventsListBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
}));

export const EventItemBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
}));
